import React from 'react';

interface Props {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  onClick?: () => void;
}

export function IconClose(props: Props) {
  const { width = 22, height = 22, color = '#34306A', ...propsSVG } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      {...propsSVG}
    >
      <path
        d="M15 7L7 15"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7L15 15"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
